import { FilterComponent } from './FilterComponent';
import { getDirectParent } from '@lib/popups';
import { getFilterId } from '@ui/table-modifier/@arch/lib';
import { OptionFilter } from '@periscopes/general/filters';
import { SonarTagDisplay } from '@ui/tags';
import { SonarText } from '@ui/text';
import { Tag } from 'antd';
import { useTags } from '@hooks';
import { COPY_SPECIFIC, PLACEHOLDERS_COPY } from '@sonar-software/sonar-ts-constants';
import React, { useMemo } from 'react';
export const TagsFilter = (props) => {
    const { format, id, onChange, value } = props;
    const tags = useTags();
    const sortedTags = useMemo(() => {
        const tagMap = tags.map((tag) => ({
            label: tag.name,
            value: tag.id
        }));
        tagMap.unshift({
            label: COPY_SPECIFIC.NO_TAGS,
            value: -1
        });
        return tagMap;
    }, [tags]);
    return (React.createElement(FilterComponent, Object.assign({}, props, { label: COPY_SPECIFIC.TAGS, tagProps: {
            value: sortedTags
                .filter((option) => value === null || value === void 0 ? void 0 : value.includes(option.value))
                .map((option) => option.label)
                .join(', ')
        } }),
        React.createElement(OptionFilter, { className: 'filter', getPopupContainer: getDirectParent, id: getFilterId(id), maxTagCount: 'responsive', mode: 'multiple', onChange: (tagIds) => onChange({
                [id]: {
                    format,
                    value: tagIds
                }
            }), optionRender: (renderProps) => (Number(renderProps.value) === -1 ?
                React.createElement(SonarText, null, COPY_SPECIFIC.NO_TAGS) :
                React.createElement(SonarTagDisplay, { noBorder: true, noClick: true, tagId: Number(renderProps.value) })), options: sortedTags, placeholder: PLACEHOLDERS_COPY.FILTER_BY_TAG, showArrow: true, tagRender: (renderProps) => {
                if (renderProps.value === -1) {
                    return React.createElement(Tag, null, COPY_SPECIFIC.NO_TAGS);
                }
                return React.createElement(SonarTagDisplay, { tagId: renderProps.value });
            }, value: value })));
};
